"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CoveoLabelsHandler = (function () {
    function CoveoLabelsHandler(labels) {
        this.labels = labels;
    }
    CoveoLabelsHandler.prototype.translate = function (key) {
        return this.labels[key] || key;
    };
    return CoveoLabelsHandler;
}());
exports.CoveoLabelsHandler = CoveoLabelsHandler;



//////////////////
// WEBPACK FOOTER
// ./src/handlers/CoveoLabelsHandler.ts
// module id = 34
// module chunks = 13 14